import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { animated, config, useTransition } from '@react-spring/web';
import { RIOJA_RED } from '../colors';
import { Small } from '../Typography';
import { getPx } from '../helpers/common';
import { ExtraSmall as ExtraSmallSpacing } from '../Typography/constants/extra-small.spacing';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../helpers/media-style';
const SPRING_CONFIG = {
  ...config.wobbly,
  clamp: true
};
const StyledWrapper = styled(animated.div)`
  ${({
  $visible
}) => styleForBreakpoints($visible, $visible => `visibility: ${$visible ? 'visible' : 'hidden'};`)}
  ${({
  $absolute
}) => styleForBreakpoints($absolute, $absolute => $absolute ? `
          position: absolute;
          left: 0;
          right: 0;
          top: 100%;
        ` : '')}
  ${({
  $noPadding
}) => styleArrayForBreakpoints([$noPadding, ExtraSmallSpacing], ([$noPadding, $value]) => !$noPadding ? `padding-top: ${getPx($value)};` : '')}
`;
const Error = ({
  component: Component = Small,
  error,
  show = true,
  visible = true,
  absolute = false,
  noPadding = false,
  ...props
}) => {
  const display = show && error && (typeof error === 'string' || /*#__PURE__*/React.isValidElement(error));
  const transitions = useTransition(display, {
    config: SPRING_CONFIG,
    from: {
      opacity: 0,
      transform: 'translate(0, -24px)'
    },
    enter: {
      opacity: 1,
      transform: 'translate(0, 0)'
    },
    leave: {
      opacity: 0
    },
    initial: null,
    immediate: !display
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, transitions((transitionStyle, display) => display && /*#__PURE__*/React.createElement(StyledWrapper, {
    style: transitionStyle,
    $visible: visible,
    $absolute: absolute,
    $noPadding: noPadding
  }, /*#__PURE__*/React.createElement(Component, _extends({
    role: "alert",
    color: RIOJA_RED
  }, props), error))));
};
export default Error;